// extracted by mini-css-extract-plugin
export var body = "_2n-1";
export var bodyPadded = "_2n-2";
export var chevron = "_2n-4";
export var chevronOpen = "_2n-5";
export var header = "_2n-0";
export var icon = "_2n-3";